// extracted by mini-css-extract-plugin
export default {"commitId":"lmlfRBFnE3ITsDf0k2YeTQ==","commitIdInputWrapper":"CrzqC9YbUs1Vo9r-yTJzeg==","tipButton":"gkx7HFVI4u2cexJcn--XGg=="};